import makeLookupModal from "../../UI/LookupModal/LookupModal";
import ResidencyStatusLookup from "./ResidencyStatusLookup";
const ResidencyStatusLookupModal = makeLookupModal(ResidencyStatusLookup, {
    pluralEntityName: "Residency Statuses",
});
export default ResidencyStatusLookupModal;
